import React from 'react';
import EventPage from '../components/Events/Events';

const EventsPage = () => {
  return <div><EventPage></EventPage></div>; 
};

export default EventsPage;
